import styled from 'styled-components';
import {Row} from '../common/Layouts/Layouts';

export const WrapperSection = styled.section(
  props => `
  background-color: ${props.theme.colors.goBrandBlue.light};
  width: 100%;
  flex-direction: column;
`,
);

export const WrapperDiv = styled.div(
  props => `
  max-width: 120rem;
  width: 100%;
  padding-top: ${props.theme.spacing.large};
  margin: 0 auto;
`,
);

export const RoomInfoItemWrapperDiv = styled(Row)(
  props => `
  padding-top: ${props.theme.spacing.base};
  padding-bottom: ${props.theme.spacing.base};
  align-items: center;
`,
);

export const RoomInfoItemDetailsTextStyling = styled.span(
  props => `
  padding-right: ${props.theme.spacing.base};
  padding-left: ${props.theme.spacing.base};
`,
);
